import React, { Fragment, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { OpenBets } from 'SharedComponents/my_bets/components';
import Context from 'Sportsbook/context';
import MarketCard from './components/market_card';
import MarketPicker from './components/market_picker/market_picker';

const MarketsView = ({
  sportEventPathId,
  marketsIds,
  open,
  picker,
  eventId,
}) => {
  const [activeMarketId, setActiveMarketId] = useState(marketsIds[0]);
  const sportEventPathIdValue = useMemo(() => ({ sportEventPathId }), [sportEventPathId]);

  return (
    <Context.Provider value={sportEventPathIdValue}>
      {picker ? (
        <>
          <MarketPicker
            marketsIds={marketsIds}
            activeMarketId={activeMarketId}
            setActiveMarketId={setActiveMarketId}
            eventId={eventId}
          />
          {activeMarketId === 'open_bets'
            ? <OpenBets eventId={eventId} />
            : <MarketCard id={activeMarketId} eventId={eventId} open />}
        </>
      ) : (
        marketsIds.map((id, index) => (
          <MarketCard id={id} open={index < open} />
        ))
      )}
    </Context.Provider>
  );
};

MarketsView.propTypes = {
  sportEventPathId: PropTypes.number.isRequired,
  eventId: PropTypes.number.isRequired,
  marketsIds: PropTypes.instanceOf(Array).isRequired,
  open: PropTypes.number.isRequired,
  picker: PropTypes.bool.isRequired,
};

export default MarketsView;
